import { Modal } from '@hopskipdrive/react-components';
import { Button } from '@rideiq/shared/components/Button';

type RiderCreationConfirmationModalProps = {
  title: string;
  body: string;
  primaryActionLabel: string;
  onPrimaryAction: () => void;
  secondaryAction?: { label: string; onClick: () => void };
};

export const RiderCreationConfirmationModal = ({
  title,
  body,
  primaryActionLabel,
  onPrimaryAction,
  secondaryAction,
}: RiderCreationConfirmationModalProps) => (
  <Modal open>
    <Modal.Title>{title}</Modal.Title>
    <Modal.Content>{body}</Modal.Content>
    <Modal.Actions>
      {secondaryAction && (
        <Button color="secondary" onClick={secondaryAction.onClick}>
          {secondaryAction.label}
        </Button>
      )}
      <Button color="primary" onClick={onPrimaryAction}>
        {primaryActionLabel}
      </Button>
    </Modal.Actions>
  </Modal>
);
